/* THE URUSHI — Kickstarter LP v3: CTA tracking, lazy loops, film facade, countdown, sticky bar */
(function () {
  'use strict';
  if (window.__ksLp2) return;
  window.__ksLp2 = true;

  /* 0. Per-ad Kickstarter referral tag. Kickstarter only reports refs created in the Creator Dashboard (random codes),
     so utm_content maps to the issued code: ?ref=<code>. Unknown or no utm_content -> the LP default (eaj3i5).
     utm_content is read from the landing URL, cleaned to [a-z0-9_] (max 30) and kept in sessionStorage
     so it survives in-page navigation. The hero's inline script does the same first (window.__ksUtm).
     Site-wide (not here): product/collection buttons ?ref=3so6wq, announcement bar ?ref=4ikl79; retargeting ads ?ref=9sm414. */
  var UK = 'tu_ks_utm_content';
  var clean = function (s) { return String(s || '').toLowerCase().replace(/[\s-]+/g, '_').replace(/[^a-z0-9_]/g, '').slice(0, 30); };
  var utm = typeof window.__ksUtm === 'string' ? window.__ksUtm : '';
  if (!utm) {
    try { var um = /[?&]utm_content=([^&#]*)/.exec(location.search); if (um) utm = clean(decodeURIComponent(um[1].replace(/\+/g, ' '))); } catch (err) {}
    try { if (utm) sessionStorage.setItem(UK, utm); else utm = clean(sessionStorage.getItem(UK)); } catch (err) {}
  }
  var REF_DEFAULT = 'eaj3i5';
  var REF_MAP = { dishwasher: '3vdu42', dark_dish: '3vdu42', sap: 'bvox1c', dark_sap: 'bvox1c', compare: '5vazy3',
    diptych: '1js1xk', dark_twocrafts: '1js1xk', warm: '9zia1t', film: 'v0ygjw' };
  var KS_REF = !utm ? REF_DEFAULT
    : Object.prototype.hasOwnProperty.call(REF_MAP, utm) ? REF_MAP[utm]
    : utm.indexOf('carousel') === 0 ? '11bgu4' : REF_DEFAULT;
  /* only links that carry the LP default are retagged (site/bar/blog refs are left alone) */
  var REF_RE = /([?&]ref=)eaj3i5(?=&|#|$)/;
  var tagLink = function (a) {
    var h = a.getAttribute('href') || '';
    if (h.indexOf('kickstarter.com/projects/theurushi-project') === -1 || !REF_RE.test(h)) return;
    var n = h.replace(REF_RE, '$1' + KS_REF);
    if (n !== h) a.setAttribute('href', n);
  };
  var tagAll = function () { [].forEach.call(document.querySelectorAll('a[href*="kickstarter.com/projects/theurushi-project"]'), tagLink); };
  tagAll();

  /* 1. CTA click tracking */
  document.addEventListener('click', function (e) {
    var ks = e.target && e.target.closest ? e.target.closest('a[href*="kickstarter.com/projects/theurushi-project"]') : null;
    if (ks) tagLink(ks);
    var a = e.target && e.target.closest ? e.target.closest('[data-cta-location]') : null;
    if (!a) return;
    var loc = a.getAttribute('data-cta-location') || 'unknown';
    var p = { location: loc, ks_ref: KS_REF, utm_content: utm || '(none)' };
    try { if (window.fbq) window.fbq('trackCustom', 'KickstarterClick', p); } catch (err) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('kickstarter_click', p);
    } catch (err) {}
    try { if (window.gtag) window.gtag('event', 'ks_cta_click', p); } catch (err) {}
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'ks_cta_click', location: loc, ks_ref: KS_REF, utm_content: p.utm_content }); } catch (err) {}
  }, true);

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* 2. Countdown */
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var cds = document.querySelectorAll('[data-ks-countdown]');
    if (cds.length) {
      var tick = function () {
        for (var i = 0; i < cds.length; i++) {
          var el = cds[i];
          var end = Date.parse(el.getAttribute('data-ks-countdown'));
          if (isNaN(end)) continue;
          var diff = Math.max(0, end - Date.now());
          if (diff === 0) {
            if (!el.getAttribute('data-done')) {
              el.setAttribute('data-done', '1');
              el.innerHTML = '<span class="ks-countdown__done">The campaign has ended.</span>';
            }
            continue;
          }
          var s = Math.floor(diff / 1000);
          var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
          for (var k in v) {
            var n = el.querySelector('[data-u="' + k + '"]');
            if (n) n.textContent = k === 'd' ? v[k] : pad(v[k]);
          }
        }
      };
      tick();
      setInterval(tick, 1000);
    }

    /* 3. Video loops: lazy, pause off-screen, no autoplay for reduced motion / save-data */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var loops = [].slice.call(document.querySelectorAll('video.ks-loop'));
    var setSrc = function (v) {
      if (v.getAttribute('src')) return;
      v.addEventListener('playing', function () {
        v.classList.add('is-playing');
        var b = v.parentNode.querySelector('.ksf-play');
        if (b) b.hidden = true;
      });
      v.muted = true;
      /* data-start: first play begins at the poster frame (seamless poster -> video); loops then run the whole film */
      var st = parseFloat(v.getAttribute('data-start'));
      if (st > 0) {
        v.addEventListener('loadedmetadata', function () { if (st < v.duration) { try { v.currentTime = st; } catch (err) {} } }, { once: true });
      }
      /* optional phone-sized source (e.g. 4:5 film under 768px) */
      var sm = v.getAttribute('data-src-sm');
      var useSm = sm && window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      v.setAttribute('src', useSm ? sm : v.getAttribute('data-src'));
      try { v.load(); } catch (err) {}
    };
    /* The film gets a play button when it can't autoplay: reduced motion, Save-Data, or a rejected play() */
    var showPlay = function (v) {
      var b = v.parentNode.querySelector('.ksf-play');
      if (!b || v.classList.contains('is-playing')) return;
      b.hidden = false;
      if (b.__ks) return;
      b.__ks = true;
      b.addEventListener('click', function () {
        setSrc(v);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    };
    if (reduce || saveData) {
      loops.forEach(function (v) { if (v.hasAttribute('data-ks-inview')) showPlay(v); });
    }
    if (loops.length && !reduce && !saveData) {
      var start = function (v) {
        setSrc(v);
        var p = v.play();
        /* AbortError = paused again while scrolling past; only a real autoplay block needs the button */
        if (p && p.catch) p.catch(function (e) { if (!e || e.name !== 'AbortError') showPlay(v); });
      };
      var visible = function (v) {
        if (v.offsetParent === null && getComputedStyle(v.parentNode).display === 'none') return false;
        return true;
      };
      if ('IntersectionObserver' in window) {
        var onIo = function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            var on = en.isIntersecting && (!v.hasAttribute('data-ks-inview') || en.intersectionRatio >= 0.25);
            if (on) {
              if (!window.__ksLoaded) return; /* never compete with the first view */
              if (!visible(v)) return;
              start(v);
            } else if (!en.isIntersecting && v.getAttribute('src')) {
              v.pause();
            }
          });
        };
        /* data-ks-inview (e.g. the film): only load once a quarter of it is actually on screen */
        var strict = function (v) { return v.hasAttribute('data-ks-inview'); };
        var io = new IntersectionObserver(onIo, { rootMargin: '100px 0px' });
        var ioStrict = new IntersectionObserver(onIo, { threshold: [0, 0.25] });
        loops.forEach(function (v) { (strict(v) ? ioStrict : io).observe(v); });
        var onLoad = function () {
          window.__ksLoaded = true;
          loops.forEach(function (v) {
            var r = v.getBoundingClientRect();
            var vh = window.innerHeight;
            var near = strict(v)
              ? (r.top < vh - r.height * 0.25 && r.bottom > r.height * 0.25)
              : (r.bottom > -200 && r.top < vh + 200);
            if (near && visible(v)) start(v);
          });
        };
        if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);
      }
    }

    /* 4. YouTube click-to-play facade */
    document.querySelectorAll('[data-ks-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + btn.getAttribute('data-ks-yt') + '?autoplay=1&rel=0';
        f.title = btn.getAttribute('data-title') || 'Film';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        btn.innerHTML = '';
        btn.appendChild(f);
        btn.removeAttribute('data-ks-yt');
        btn.style.cursor = 'default';
      }, { once: true });
    });

    /* 4a. Live Kickstarter widget inside <details>: the iframe is created only when opened; open by default on desktop */
    document.querySelectorAll('details[data-ks-live]').forEach(function (d) {
      var mount = function () {
        if (!d.open || d.__ks) return;
        d.__ks = true;
        var f = document.createElement('iframe');
        f.src = d.getAttribute('data-ks-live');
        f.width = '220'; f.height = '420';
        f.setAttribute('scrolling', 'no');
        f.setAttribute('frameborder', '0');
        f.title = 'THE URUSHI on Kickstarter, live funding status';
        var box = d.querySelector('.kso-live-frame') || d;
        box.appendChild(f);
      };
      d.addEventListener('toggle', mount);
      if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) d.open = true;
      mount();
    });

    /* 4b. YouTube in an on-page dialog (keeps visitors on the LP). No <dialog> support: the link's new tab. */
    document.querySelectorAll('[data-ks-yt-modal]').forEach(function (link) {
      if (typeof HTMLDialogElement !== 'function') return;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var d = document.createElement('dialog');
        d.className = 'ks-yt-modal';
        d.setAttribute('aria-label', link.getAttribute('data-title') || 'Film');
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'ks-yt-modal__close';
        close.setAttribute('aria-label', 'Close video');
        close.innerHTML = '&times;';
        var frame = document.createElement('div');
        frame.className = 'ks-yt-modal__frame';
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(link.getAttribute('data-ks-yt-modal')) + '?autoplay=1&rel=0&playsinline=1';
        f.title = link.getAttribute('data-title') || 'Film';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        frame.appendChild(f);
        d.appendChild(close);
        d.appendChild(frame);
        document.body.appendChild(d);
        close.addEventListener('click', function () { d.close(); });
        d.addEventListener('click', function (ev) { if (ev.target === d) d.close(); });
        d.addEventListener('close', function () { d.remove(); try { link.focus(); } catch (err) {} });
        d.showModal();
        close.focus();
      });
    });

    /* 5. Sticky CTA: mounted at end of <body> (sections get transforms from the reveal script) */
    var sticky = document.querySelector('[data-ks-sticky]');
    if (sticky) {
      document.body.appendChild(sticky);
      var heroCta = document.querySelector('[data-ks-hero-cta]');
      var blockers = [].slice.call(document.querySelectorAll('[data-ks-hide-sticky]'));
      /* rect-based (not IntersectionObserver) so anchor jumps stay correct.
         On when the hero CTA is off screen (above OR below the fold, so phones get a CTA in the first view)
         and no offer / closing section is on screen. */
      var update = function () {
        var vh = window.innerHeight;
        var heroVisible = false;
        if (heroCta) {
          var hr = heroCta.getBoundingClientRect();
          heroVisible = hr.top < vh && hr.bottom > 0;
        }
        var blocked = false;
        for (var i = 0; i < blockers.length; i++) {
          var r = blockers[i].getBoundingClientRect();
          if (r.top < vh && r.bottom > 0) { blocked = true; break; }
        }
        sticky.classList.toggle('is-on', !heroVisible && !blocked);
      };
      var queued = false;
      var onScroll = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; update(); setTop(); });
      };
      /* desktop: sit just below the theme header */
      var header = document.querySelector('.section-header');
      var setTop = function () {
        var top = 0;
        if (header) {
          var r = header.getBoundingClientRect();
          top = Math.max(0, Math.round(r.bottom));
        }
        sticky.style.setProperty('--ks-sticky-top', top + 'px');
      };
      update();
      setTop();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
  });
})();
